/* global Macy */

(function() {
  "use strict";

  angular
    .module("app")
    .controller("AssetMapTableController", [
      "$scope",
      "$sanitize",
      "$timeout",
      AssetMapTableController
    ]);

  function AssetMapTableController($scope, $sanitize, $timeout) {
    // A custom filter that returns all groups (domains) with selected assets
    $scope.groupsWithSelectedAssets = function(groups) {
      var groupsArr = [];
      var groupIdsArr = [];

      var addAssetsToTable = function(domain, parentGroup) {
        if (domain.children) {
          domain.children.forEach(function(asset, ind, arr) {
            // We only want to add each domain/group once
            // If there's a parent group, we'll want to use that ID
            var groupID;
            if (parentGroup) {
              groupID = parentGroup.id;
            }
            else {
              groupID = domain.id;
            }

            if (
              $scope.state.selectedAssets.indexOf(asset.id) >= 0 &&
              groupIdsArr.indexOf(groupID) === -1
            ) {
              groupsArr.push(parentGroup ? parentGroup : domain);
              groupIdsArr.push(groupID);
            }

            // If this specific asset has child assets, capture those too
            // A child asset might be selected even if a parent isn't, so we want to make sure we
            // catch that and show the group as expected
            if (asset.children) {
              addAssetsToTable(asset, domain);
            }
          });
        }
      };

      groups.forEach(function(group, ind, arr) {
        addAssetsToTable(group);
      });

      return groupsArr;
    };

    // Check if an asset is, or any children of the asset are selected
    // Per the feature spec, parent/sibling assets need to be visible if any child is selected
    $scope.assetOrChildIsSelected = function(asset) {
      var assetIsGroup = Object.keys($scope.state.assetsByGroup).indexOf(
        asset.toString()
      );

      if (assetIsGroup >= 0) {
        var shouldReturn = false;
        $scope.state.assetsByGroup[asset].forEach(function(child, ind, arr) {
          if ($scope.state.selectedAssets.indexOf(child) >= 0) {
            shouldReturn = true;
            return;
          }
        });
        return shouldReturn;
      }
      else {
        return $scope.state.selectedAssets.indexOf(asset) >= 0;
      }
    };

    var refreshMasonry = function() {
      $scope.state.selectedCommunities.communities.forEach(function(
        elm,
        ind,
        arr
      ) {
        // Macy doesn't like the idea of multiple masonry containers, so we get around that by
        // re-initializing each container every time. Definitely not ideal or optimal, but it works.
        Macy.init({
          container: ".macy-wrapper-" + ind,
          margin: 24,
          columns: 3
        });
      });
    };

    var assetsTable = {};

    $scope.$watch(
      "state.selectedAssets",
      function(oldVal, newVal) {
        if (oldVal === newVal) {
          return false;
        }

        $scope.state.selectedAssets.forEach(function(asset, ind, arr) {
          for (var group in $scope.state.assetsByGroup) {
            assetsTable[group] = assetsTable[group] || [];
            if (
              $scope.state.assetsByGroup[group].indexOf(asset) >= 0 &&
              assetsTable[group].indexOf(asset) === -1
            ) {
              assetsTable[group].push(asset);
            }
          }
        });

        // Since Macy isn't tied to Angular, this timeout prevents a race condition if Angular
        // takes longer to update than Macy does to update
        $timeout(refreshMasonry, 175);
      },
      true
    );

    $scope.$watch(
      "state.selectedCommunities",
      function(oldVal, newVal) {
        if (oldVal === newVal) {
          return false;
        }

        // Since Macy isn't tied to Angular, this timeout prevents a race condition if Angular
        // takes longer to update than Macy does to update
        $timeout(refreshMasonry, 175);
      },
      true
    );
  }
})();
